<template>
  <v-container fluid class="px-0">
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="">{{ getTitle }}</h1>
    <h4 class="ml-1">{{ getSubTitle }}</h4>

    <!-- search -->
    <log-search :loading="loading" @search="doSearch" />
    <!-- table -->
    <v-data-table
      class="mb-4 custom-table sticky-header"
      :loading="loading || paginationloading"
      :headers="filteredHeader"
      :items="filterItemList"
      :hide-default-footer="hideFooter"
      :header-props="{
        sortByText: $t('Rūšiuoti pagal'),
      }"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: $t('Rodyti po:'),
        itemsPerPageAllText: $t('visi'),
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <!-- custom templates -->
      <template #[`item.actions`]="{ item }">
        <div class="nowrap">
          <el-table-action
            :item="setItemParam(item)"
            @viewInModaltem="viewInModaltem(item)"
          />
        </div>
      </template>
      <!-- basic templates -->
      <template slot="loading"> {{ $t('Kraunasi...') }} </template>
      <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
      <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
      <template #[`footer.page-text`]="props">
        {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }}
        {{ $t('iš') }}
        {{ props.itemsLength }}
      </template>
    </v-data-table>
        <!-- modals -->
      <modal-broker-logs
      logs
      :log-title="getModalTitle"
      v-model="showModal"
      :loading="loading"
      :item="selectedItem"
    />
  </v-container>
</template>

<script>
import LogSearch from './LogSearch'
import userRole from '@/mixins/userRole'
import { mapGetters } from 'vuex'
import math from '@/mixins/math'
import ModalBrokerLogs from '@/components/modals/ModalBrokerLogs'
export default {
  name: 'LogForm',
  components: {
    LogSearch,
    ModalBrokerLogs,
  },
  mixins: [userRole, math],
  data() {
    return {
      pageloading: true,
      loading: true,
      paginationloading: false,
      search: null,
      listData: [],
      searchData: {},
      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 100,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },

      showModal: false,
      selectedItem: null,

      showConfirmModal: false,
      confirmModalTitle: '',
      confirmModalText: '',
    }
  },
  computed: {
    ...mapGetters(['listParams']),
    getHeaderTitle() {
      switch (this.$route.name) {
        case 'adminLogNirvar':
          return 'Užklausos į NIRVAR data ir laikas'
        case 'adminLogSaperion':
          return 'Užklausos į SAPERION data ir laikas'
        case 'adminLogJarProcuracy':
          return 'Užklausos į JAR data ir laikas'
        case 'adminLogAsmenys':
          return 'Užklausos į ASMENYS data ir laikas'
        case 'adminLogPas':
          return 'Užklausos į PAS data ir laikas'
        case 'adminLogBroker':
          return 'BROKER užklausų (log) žurnalas'
        default:
          return ''
      }
    },
    getTitle() {
      switch (this.$route.name) {
        case 'adminLogNirvar':
          return 'NIRVAR užklausų (log) žurnalas'
        case 'adminLogSaperion':
          return 'SAPERION užklausų (log) žurnalas'
        case 'adminLogJarProcuracy':
          return 'JAR užklausų (log) žurnalas'
        case 'adminLogAsmenys':
          return 'ASMENYS užklausų (log) žurnalas'
        case 'adminLogPas':
          return 'PAS užklausų (log) žurnalas'
        case 'adminLogBroker':
          return 'BROKER užklausų (log) žurnalas'
        default:
          return ''
      }
    },
    getSubTitle() {
      switch (this.$route.name) {
        case 'adminLogNirvar':
          return 'Periodinio tikrinimo užklausos'
        case 'adminLogSaperion':
          return 'Dokumentų padėjimo užklausos'
        case 'adminLogJarProcuracy':
          return 'Prokūrų duomenų perdavimo užklausos'
        case 'adminLogAsmenys':
          return 'Asmenų įrašymo užklausos'
        case 'adminLogPas':
          return 'Paslaugų įrašymo užklausos'
        case 'adminLogBroker':
          return ''
        default:
          return ''
      }
    },
    getURL() {
      switch (this.$route.name) {
        case 'adminLogNirvar':
          return 'logs/nirvar'
        case 'adminLogSaperion':
          return 'logs/saperion'
        case 'adminLogJarProcuracy':
          return 'logs/jarProcuracy'
        case 'adminLogAsmenys':
          return 'logs/asmenys'
        case 'adminLogPas':
          return 'logs/pas'
        case 'adminLogBroker':
          return ''
        default:
          return ''
      }
    },
     getModalTitle() {
      switch (this.$route.name) {
        case 'adminLogNirvar':
          return 'NIRVAR užklausa'
        case 'adminLogSaperion':
          return 'SAPERION užklausa'
        case 'adminLogJarProcuracy':
          return 'JAR užklausa'
        case 'adminLogAsmenys':
          return 'ASMENYS užklausa'
        case 'adminLogPas':
          return 'PAS užklausa'
        case 'adminLogBroker':
          return 'BROKER užklausa'
        default:
          return ''
      }
    },
    headers() {
      return [
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
        },
        {
          text: this.$t('ID'),
          align: 'center',
          value: 'id',
        },
        {
          text: this.$t('Adresas / metodas'),
          align: 'center',
          value: 'address',
        },
        {
          text: this.getHeaderTitle,
          align: 'center',
          value: 'created_at',
        },
      ]
    },

    filteredHeader() {
      return this.headers.filter((item) => {
        return !item.hide
      })
    },

    filterItemList() {
      return this.listData.map((item) => {
        return item
      })
    },
    hideFooter() {
      return this.pagination.total <= 10
    },
  },
  created() {
    this.setlistParams()
  },
  methods: {
    setItemParam(item) {
        item.canViewInModal = true
      return item
    },
    setlistParams() {
      if (
        this.listParams &&
        this.pagination.pageSize != this.listParams.pageSize &&
        this.listParams.pageSize != null
      ) {
        this.pagination.pageSize = this.listParams.pageSize
      }
    },
    getData(resetPageNr = false) {
      if (resetPageNr) {
        this.pagination.page = 1
      }
      const data = {
        ...this.pagination,
        search: this.searchData,
      }
      this.$axios
        .post(this.getURL, data)
        .then((res) => {
          this.listData = res.data.logs
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    viewInModaltem(item) {
      this.$axios
        .get(`${this.getURL}/${item.id}`)
        .then((res) => {
          this.selectedItem = res.data.log
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
      this.showModal = true
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.$store.dispatch('listParams', {
        pageSize: pagination.itemsPerPage,
      })
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    doSearch(searchData) {
      this.searchData = searchData
      this.loading = true
      this.getData(true)
    },
  },
}
</script>
